module.exports = __webpack_public_path__ + "img/ranheim-logo-text.27029e6e.png";